var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 168,
    viewBox: "0 0 175 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4991 90.0468C102.644 67.28 100.976 39.4983 88.1992 18.447C87.0394 16.5364 84.007 18.0528 85.1011 20.0538C96.4302 40.8985 99.3763 65.2799 90.9569 87.8168C82.3535 110.911 62.6822 128.391 39.5211 136.122C38.4703 136.442 38.7861 138.137 39.9221 137.829C64.001 131.368 84.2288 113.115 93.4991 90.0468Z",
    fill: "#FF6E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.316 25.416C111.549 23.4371 108.704 24.9686 109.395 26.9308C117.507 48.5899 117.276 72.4914 108.746 93.9895C99.7457 116.231 81.6524 134.255 59.7899 143.904C58.6434 144.409 59.5402 146.073 60.6739 145.608C72.1084 140.949 82.5082 134.073 91.2745 125.378C100.041 116.682 107.001 106.339 111.753 94.9424C120.768 72.6804 120.969 47.8211 112.316 25.416Z",
    fill: "#FF6E40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.377 37.1252C130.627 35.1594 127.188 36.3687 127.853 38.3894C133.845 56.4596 135.189 75.341 129.71 93.7509C124.231 112.161 112.852 127.21 98.1571 139.472C97.1675 140.301 98.3882 142.09 99.4731 141.358C132.243 119.248 145.367 73.701 131.377 37.1252Z",
    fill: "#FF6E40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.689 61.6263C154.761 83.0796 150.811 106.329 135.76 123.485C135.1 124.233 136.083 125.367 136.832 124.641C153.522 108.494 159.751 82.1247 151.352 60.3689C150.539 58.3012 147.006 59.5477 147.689 61.6263Z",
    fill: "#FF6E40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurves);
export default __webpack_public_path__ + "static/media/curves.442ee4bb1d1e37c587953fe22f223d2b.svg";
export { ForwardRef as ReactComponent };